/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.nav__menus' ).slideToggle();
        $( 'body' ).toggleClass( 'overflow-hidden' );
      } );

      ScrollTrigger.matchMedia( {'(min-width:768px)': function() {
        if ( $( '.navbar' ).length > 0 ) {
          ScrollTrigger.create( {
            // markers: true,
            trigger: 'body',
            start: '10px 0',
            end: '10px 0',
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( '.logo--header' ).fadeOut( 300, function() {
                  $( '.logo--header-mark' ).fadeIn( 500 );
                } );
                $( '.navbar' ).addClass( 'is-scrolled' );
                $( ':root' ).get( 0 ).style.setProperty( '--navbarHeight', '114px' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              $( '.logo--header' ).fadeOut( 300, function() {
                $( '.logo--header-mark' ).fadeIn( 500 );
              } );
              $( '.navbar' ).addClass( 'is-scrolled' );
              $( ':root' ).attr( 'style', '--navbarHeight:114px' );
            },
            onEnterBack: ( {progress, direction, isActive} ) => {
              if ( progress < 0.1 ) {
                $( '.logo--header-mark' ).fadeOut( 300, function() {
                  $( '.logo--header' ).fadeIn( 500 );
                } );
                $( '.navbar' ).removeClass( 'is-scrolled' );

                $( ':root' ).get( 0 ).style.setProperty( '--navbarHeight', '134px' );
              }
            },
          } );
        }
      }} );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( document.querySelector( '.nav__menus' ) ) {
            document.querySelector( '.nav__menus' ).style.removeProperty( 'display' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      document.querySelectorAll( '.link-gated' ).forEach( ( el ) => {
        el.addEventListener( 'click', ( e ) => {
          e.preventDefault();
          document.querySelector( '.gated-form .download-link input' ).value = el.href;
          $.magnificPopup.open( {
            items: {
              src: '.gated-form',
              type: 'inline',
            },
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
